import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import MaterialStatCard from "./MaterialStatCard";
import useMaterials from "../hooks/materialsData";
import "./AreaDetails.css";

const AreaDetails = ({ selectedArea }) => {
  const { materials} = useMaterials();

  const selectedMaterials = materials.filter(
    (mat) => mat.application === selectedArea
  );
  console.log(selectedMaterials);

  const commonMaterials = selectedMaterials.filter((mat) => mat.type === "common");
  const ecoMaterials = selectedMaterials.filter((mat) => mat.type === "eco");

  return (
    <>

      <div>
        <motion.div
          className="material-stat-card-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          {commonMaterials.map((material, index) => {
            return <MaterialStatCard key={`common-${index}`} material={material} type="traditional" />;
          })}
          {ecoMaterials.map((material, index) => {
            return <MaterialStatCard key={`eco-${index}`} material={material} type="biobased" />;
          })}
        </motion.div>
      </div>
    </>
  );
};

AreaDetails.propTypes = {
  selectedArea: PropTypes.string,
};

export default AreaDetails;
